import script from "./BodorHub.vue?vue&type=script&setup=true&lang=js"
export * from "./BodorHub.vue?vue&type=script&setup=true&lang=js"

import "./BodorHub.vue?vue&type=style&index=0&id=f5d24f74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5d24f74"]])

export default __exports__